<template>
    <div>
        <div class="mb-8">
            <Input label="Hotel name" placeholder="Hotel name" id="hotel-name">
                <template #input>
                    <HotelDropdown
                        :externalActions="true"
                        @propertyChanged="hotelSelected"
                        :hotel="activeRedemption.name"
                    />
                </template>
            </Input>
        </div>

        <SafeDateRangePicker
            v-model:start-date="activeRedemption.start_date"
            v-model:end-date="activeRedemption.end_date"
            :config="dateStartConfig"
            class="mb-8"
        >
            <template #default="{ openMenu, startValue, endValue }">
                <div class="grid grid-cols-2 gap-4">
                    <div class="col-span-1">
                        <Input
                            label="Check in" placeholder="Check in"
                            name="start_date" id="check-in"
                            :options="{ icon: 'calendar', iconPosition: 'left' }"
                            :errors="tripFormErrors"
                        >
                            <template #input>
                                <input
                                    :value="startValue" readonly @click="openMenu"
                                    name="start_date" id="check-in"
                                    class="relative block w-full h-10 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-800 dark:text-gray-100 text-sm placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm cursor-pointer"
                                    placeholder="Check in"
                                    :class="{ '!border-red-500': tripFormErrors['start_date'] }"
                                    data-hs-id="hs-redemption-check-in"
                                />
                            </template>
                        </Input>
                    </div>
                    <div class="col-span-1">
                        <Input
                            label="Check out" placeholder="Check out"
                            name="end_date" id="check-out"
                            :options="{ icon: 'calendar', iconPosition: 'left' }"
                        >
                            <template #input>
                                <input
                                    :value="endValue" readonly @click="openMenu"
                                    name="end_date" id="check-out"
                                    class="relative text-sm block w-full h-10 rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-800 dark:text-gray-100 placeholder:text-slate-500 dark:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm cursor-pointer"
                                    placeholder="Check out"
                                    data-hs-id="hs-redemption-check-out"
                                />
                            </template>
                        </Input>
                    </div>
                </div>
            </template>
        </SafeDateRangePicker>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import SafeDateRangePicker from '@/components/ui/SafeDateRangePicker.vue';
import Input from '@/components/ui/inputs/ui-input.vue';
import HotelDropdown from '@/components/trips/modals/steps/hotel-dropdown.vue';

defineProps({
    dateStartConfig: { type: Object, required: true },
});

const { activeRedemption, tripFormErrors } = storeToRefs(useTripsStore());

const hotelSelected = (hotel) => {
    if (hotel) {
        activeRedemption.value.hotel_id = hotel.id;
        activeRedemption.value.name = hotel.name;
    } else {
        activeRedemption.value.hotel_id = null;
        activeRedemption.value.name = null;
    }
};
</script>
